import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';

const shouldShowLogoMakerBanner = () => {
    const { locale } = getContext();

    return locale === DEFAULT_FIVERR_LOCALE;
};

export default shouldShowLogoMakerBanner;
